import React from 'react';
import PropTypes from 'prop-types';
import ListByDate from 'components/ListByDate';
import Card from 'components/Card';
import Destinations from 'components/Destinations';
import Assignments from 'components/Assignments';
import StatusTag from 'components/StatusTag';
import Price from 'components/Price';
import LoadDetails from 'components/LoadDetails';

const JourneysList = ({
  journeys,
  parentClass,
  handleClick,
  showPrice,
  avoidOrdering,
}) => {
  return (
    <div className="journeys-list" data-testid="journeys-list">
      <ListByDate
        items={journeys}
        dateField="start_time_from"
        timeZoneField="start_time_from_tz"
        avoidOrdering
      >
        {({ item }) => {
          return (
            <Card item={item} handleClick={() => handleClick(item.id)}>
              <Card.Header>
                <div
                  className={`${parentClass}__header`}
                  data-testid={parentClass}
                >
                  <div className={`${parentClass}__id`}>{`J${item.id}`}</div>
                  <div className={`${parentClass}__status`}>
                    <StatusTag status={item.status} />
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                <div className={`${parentClass}__body`}>
                  <Destinations
                    start_time_from={item.start_time_from}
                    start_time_to={item.start_time_to}
                    label_from={item.label_from}
                    country_from={item.country_from}
                    end_time_from={item.end_time_from}
                    end_time_to={item.end_time_to}
                    start_time_from_tz={item.start_time_from_tz}
                    start_time_to_tz={item.start_time_to_tz}
                    end_time_from_tz={item.end_time_from_tz}
                    end_time_to_tz={item.end_time_to_tz}
                    label_to={item.label_to}
                    country_to={item.country_to}
                    distance={item.distance}
                    stops={item.pickup_count + item.dropoff_count}
                    withStops
                  />
                  <div className={`${parentClass}__load-details-container`}>
                    <LoadDetails
                      numberOfItems={item.max_equivalent_pallets}
                      mass={item.sum_weight}
                      height={item.item_height}
                      extras={item.extras}
                      bottomAlign
                    />
                  </div>
                  <div className={`${parentClass}__assignment-container`}>
                    <Assignments
                      driverId={item.driver_id}
                      vehiclesIds={item.vehicles_id}
                      driverConfirmed={item.driver_confirmed}
                    />
                  </div>
                </div>
              </Card.Body>
              {showPrice && (
                <>
                  <Card.Footer>
                    <div className={`${parentClass}__footer`}>
                      <Price
                        price={item.net_full_cost}
                        currency={item.currency}
                        showPrice={parseFloat(item.net_full_cost) > 0.0}
                        vat={item.gross_full_cost}
                      />
                    </div>
                  </Card.Footer>
                </>
              )}
            </Card>
          );
        }}
      </ListByDate>
    </div>
  );
};

JourneysList.defaultProps = {
  showPrice: false,
};

JourneysList.propTypes = {
  journeys: PropTypes.array.isRequired,
  parentClass: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  showPrice: PropTypes.bool,
};
export default JourneysList;
